import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import App from './1_environment/App/App';
import { StringsContext } from './contexts/StringsContext';
import { getStringsByLanguage } from './utils/languageUtils';

export default {
    new: (config) => {
        const props = {
            token: config.token,
            brokerConfigId: config.brokerConfigId,
            apiDomain: config.apiDomain,
            warningTimeout: config.warningTimeout,
            sessionTimeout: config.sessionTimeout,
            sessionTimeoutCallback: config?.sessionTimeoutCallback || null,
            updateTokenCallback: config?.updateTokenCallback || null
        };

        const { warningHeader, warningBody, warningButton, sessionHeader, sessionBody, sessionButton, language } = config;
        const customStrings = {
            ...(warningHeader && { warningHeader }),
            ...(warningBody && { warningBody }),
            ...(warningButton && { warningButton }),
            ...(sessionHeader && { sessionHeader }),
            ...(sessionBody && { sessionBody }),
            ...(sessionButton && { sessionButton })
        };

        // Combine default strings with overridden strings
        const strings = Object.assign({}, getStringsByLanguage(language), customStrings);

        const containerElement = document.querySelector(config.selector);
        const root = createRoot(containerElement);

        const appRef = createRef();

        return {
            render: (onRendered = null) => {
                console.info('Taylor Corp - Timeout Widget', {
                    BuildType: BUILD_TYPE,
                    Environment: ENVIRONMENT,
                    CommitHash: COMMIT_HASH,
                    Version: VERSION
                }); // eslint-disable-line no-console

                root.render(
                    <React.StrictMode>
                        <StringsContext.Provider value={strings}>
                            <App {...props} ref={appRef} onInitialized={onRendered} />
                        </StringsContext.Provider>
                    </React.StrictMode>
                );
            },
            setSessionTimeoutCallback: (callback) => {
                if (appRef.current) {
                    appRef.current.setSessionTimeoutCallback(callback);
                }
                else {
                    console.warn('The call to "TimeoutWidget.setSessionTimeoutCallback" was ignored, likely because "render" has not been called yet or the app has not completed rendering, as the render method does not execute synchronously. Use the "render" method\'s optional "onRendered" callback to run code after the app has finished rendering.');
                }
            },
            setUpdateTokenCallback(callback) {
                if (appRef.current) {
                    appRef.current.setUpdateTokenCallback(callback);
                }
                else {
                    console.warn('The call to "TimeoutWidget.setUpdateTokenCallback" was ignored, likely because "render" has not been called yet or the app has not completed rendering, as the render method does not execute synchronously. Use the "render" method\'s optional "onRendered" callback to run code after the app has finished rendering.');
                }
            },
            resetToken(brokerConfigId) {
                if (appRef.current) {
                    appRef.current.resetToken(brokerConfigId);
                }
                else {
                    console.warn('The call to "TimeoutWidget.resetToken" was ignored, likely because "render" has not been called yet or the app has not completed rendering, as the render method does not execute synchronously. Use the "render" method\'s optional "onRendered" callback to run code after the app has finished rendering.');
                }
            },
            unmount: () => {
                root.unmount();
            }
        };
    }
};